import React, { useEffect } from 'react';
import { CenterFrameLayout } from 'Layouts';
import { StaticLinkButton, LinkSubmitButton } from 'Components/Fields/Buttons';
import { logger } from 'Utils/Logger';
import { encodeSearchParams } from 'Utils/Path';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import { useStore } from 'Hooks/useStore';
import './CurrentSubscriber.css';

export const CurrentSubscriberContainer = () => {
  const {
    routes,
    defaultConfig: { rootDomain },
  } = useStore('appConfig');
  const { isDeviceActivation } = useStore('secondScreen');
  const returnTo = isDefaultPlanFlow() ? routes.signupCreateAccount : routes.signupPlans;

  const searchParams = encodeSearchParams({ return_to: returnTo });
  const logoutLinkWithReturn = `${routes.signout}?${searchParams}`;

  useEffect(() => {
    logger.started('current subscriber');
  }, []);

  useEffect(() => {
    if (isDeviceActivation) {
      trackEvent(TRACKING_ENUMS.EVENT_PROFILE_ACCESS_ACTIVATION_COMPLETED, {
        page_start_source: 'general',
      });
    }
  }, [isDeviceActivation]);

  return (
    <CenterFrameLayout
      title="Looks like you already have a subscription"
      showLoader={false}
      customClass="currentSubscriber"
    >
      <div className="currentSubscriberContainer">
        <LinkSubmitButton path={logoutLinkWithReturn} text="Use a different email" />
        <br />
        <StaticLinkButton path={rootDomain} text="Continue Watching" className="continueWatching" />
        <br />
      </div>
    </CenterFrameLayout>
  );
};
